import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Error, ErrorResponse } from '../../models/error.model';
import { Message } from '../../models/message.model';
import { Company, CompanyResponse } from '../../models/company.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthCompany {
  static apiResponse: ApiResponse

  public static async getCompany(
    api_key: string,
    id_company: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let companyResponseMain: CompanyResponse | null = null
      let companyResponseOther: CompanyResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/company.data.json').then(response => { companyResponseMain = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/company.other.data.json').then(response => { companyResponseOther = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (companyResponseMain!.data.id === id_company || companyResponseOther!.data.id === id_company) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: (companyResponseMain!.success === true && companyResponseOther!.success === true) ? (id_company === companyResponseMain!.data.id) ? companyResponseMain!.data : companyResponseOther!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/companies/${id_company}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async putCompany(
    api_key: string,
    id_company: string,
    name: string,
    logo: any,
    street: string,
    street_number: string,
    additional: string,
    administrative_area: string,
    city: string,
    zip_code: string,
    country: string,
    email: string,
    phone: string,
    website: string,
    register_number: string,
    vat_number: string,
    currency_code: string,
    currency_name: string,
    currency_symbol: string,
    language: string,
    legal_form: string = '',
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let company: Company | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/company.data.json').then(response => { company = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (company!.id === id_company) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/companies/${id_company}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = new FormData()
      data.append('logo', logo)
      data.append('name', name)
      data.append('phone', phone)
      data.append('email', email)
      data.append('website', website)
      data.append('register_number', register_number)
      data.append('vat_number', vat_number)
      data.append('street', street)
      data.append('number', street_number)
      data.append('additional', additional)
      data.append('administrative_area', administrative_area)
      data.append('city', city)
      data.append('zip_code', zip_code)
      data.append('country', country)
      data.append('currency_code', currency_code)
      data.append('currency_name', currency_name)
      data.append('currency_symbol', currency_symbol)
      data.append('language', language)
      if (legal_form) data.append('legal_form', legal_form)

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.error
        }
      })
    }

    return this.apiResponse
  }
}
